import axios from "../axios";

// Unified Wallet & Coin Recharge Services

/**
 * Get the current user's wallet balance
 * GET /api/user/walletBalance
 */
export const getWalletBalance = async () => {
  try {
    const response = await axios.get("/walletBalance");
    return response.data;
  } catch (error) {
    throw error || "Failed to fetch wallet balance";
  }
};

/**
 * Create a recharge order
 * POST /api/user/createRechargeOrder
 * @param {number} amount - Amount in INR
 */
export const createRechargeOrder = async (amount) => {
  try {
    // Current window location for success/failed redirects
    const currentUrl = window.location.href;

    const response = await axios.post("/createRechargeOrder", {
      amount,
      successUrl: currentUrl,
      failedUrl: currentUrl,
    });
    return response.data;
  } catch (error) {
    throw error || "Failed to create order";
  }
};

/**
 * Get recharge history
 * GET /api/user/rechargeHistory
 */
export const getRechargeHistory = async (page = 1, limit = 10) => {
  try {
    const response = await axios.get(
      `/rechargeHistory?page=${page}&limit=${limit}`,
    );
    return response.data;
  } catch (error) {
    throw error || "Failed to fetch recharge history";
  }
};

/**
 * Get coin transaction history
 * GET /api/user/coinTransactions
 */
export const getCoinTransactions = async (page = 1, limit = 10, type = "") => {
  try {
    let query = `/coinTransactions?page=${page}&limit=${limit}`;
    if (type) {
      query += `&type=${type}`;
    }
    const response = await axios.get(query);
    return response.data;
  } catch (error) {
    throw error|| "Failed to fetch transactions";
  }
};

/**
 * Pay for a contest with coins
 * POST /api/user/payContestWithCoins
 */
export const payContestWithCoins = async (contestId) => {
  try {
    const response = await axios.post("/payContestWithCoins", { contestId });
    return response.data;
  } catch (error) {
    throw error || "Payment failed";
  }
};

/**
 * Pay for a plan with coins
 * POST /api/user/payPlanWithCoins
 */
export const payPlanWithCoins = async (courseId) => {
  try {
    const response = await axios.post("/payPlanWithCoins", { courseId });
    return response.data;
  } catch (error) {
    throw error || "Payment failed";
  }
};

/**
 * Withdraw from Question Earnings (Locked Balance)
 * POST /api/withdrawWalletAmount
 */
export const withdrawWalletAmount = async (amount) => {
  try {
    const response = await axios.post("/withdrawWalletAmount", { amount });
    return response.data;
  } catch (error) {
    throw error || "Withdrawal failed";
  }
};

/**
 * Withdraw from Contest Winnings
 * POST /api/withdrawContestWalletAmount
 */
/**
 * Withdraw from Unified Wallet (Contest > Referral > Question)
 * POST /api/unifiedWithdraw
 */
export const unifiedWithdraw = async (amount) => {
  try {
    const response = await axios.post("/unifiedWithdraw", { amount });
    return response.data;
  } catch (error) {
    throw error
  }
};

/**
 * Get unified withdrawal history
 * GET /api/getUnifiedWithdrawalHistory
 */
export const getUnifiedWithdrawalHistory = async (page = 1, limit = 10) => {
  try {
    const response = await axios.get(
      `/getUnifiedWithdrawalHistory?page=${page}&limit=${limit}`,
    );
    return response.data;
  } catch (error) {
    throw error || "Failed to fetch withdrawal history";
  }
};
